module.exports = __webpack_public_path__ + "media/images/flowchart_800-76bc437ccbbbf1aa16796049f6bced8c.svg";